import { atsApiQuery } from '..';

export const offerInitiationApi = atsApiQuery.injectEndpoints({
  endpoints: (builder) => {
    return {
      GetOfferById: builder.query({
        providesTags: ['GetOfferById'],
        transformResponse: (response) => response?.data,
        query: ({ id }) => {
          return {
            method: 'get',
            url: `/ats_offers/${id}`,
          };
        },
      }),

      pollOfferById: builder.query({
        transformResponse: (response) => response?.data,
        query: ({ id }) => {
          return {
            method: 'get',
            url: `/ats_offers/${id}/poll_status`,
          };
        },
      }),

      getApplicantById: builder.query({
        transformResponse: (response) => response?.data,
        query: ({ id }) => {
          return {
            method: 'get',
            url: `/ats_applications/${id}`,
          };
        },
      }),

      getApplicantOfferActivities: builder.query({
        transformResponse: (response) => response,
        query: ({ id, params }) => {
          return {
            method: 'get',
            url: `/ats_applications/${id}/offer_activities`,
            params,
          };
        },
      }),

      createOffer: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ payload }) => {
          return {
            url: '/ats_offers',
            method: 'post',
            data: payload,
          };
        },
        // invalidatesTags: ['GetOfferById'],
      }),

      updateOffer: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ payload, id }) => {
          return {
            url: `/ats_offers/${id}`,
            method: 'put',
            data: payload,
          };
        },
        // invalidatesTags: ['GetOfferById'],
      }),

      offerStatus: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ id, event, req_id }) => {
          return {
            url: `ats_offers/${id}/update_status/${event}`,
            method: 'put',
            ...(req_id && { data: { req_id } }),
          };
        },
        // invalidatesTags: ['GetOfferById'],
      }),

      uploadReplacement: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ id, file }) => {
          const formData = new FormData();
          formData.append('offer_document', file);
          formData.append('name', 'test');

          return {
            url: `ats_offers/${id}/upload_replacement`,
            method: 'put',
            data: formData,
          };
        },
        // invalidatesTags: ['GetOfferById'],
      }),

      uploadAttachment: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ id, attachments = [] }) => {
          const formData = new FormData();
          if (Array.isArray(attachments)) {
            attachments.forEach((item) => {
              formData.append(`attachments`, item);
            });
          }
          return {
            url: `ats_offers/${id}/upload_attachment`,
            method: 'put',
            data: formData,
          };
        },
      }),

      sendEmail: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ id, payload }) => {
          return {
            url: `ats_offers/${id}/send_email`,
            method: 'put',
            data: payload,
          };
        },
      }),

      sendWithDocuSign: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ id, payload }) => {
          return {
            url: `ats_offers/${id}/send_docusign`,
            method: 'post',
            data: payload,
          };
        },
      }),

      sendWithPandaDoc: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ id, payload }) => {
          return {
            url: `ats_offers/${id}/send_pandadoc`,
            method: 'post',
            data: payload,
          };
        },
      }),

      sendWithAdobe: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ id, payload }) => {
          return {
            url: `ats_offers/${id}/send_adobe`,
            method: 'post',
            data: payload,
          };
        },
      }),
    };
  },
  overrideExisting: true,
});

export const {
  useGetOfferByIdQuery,
  useLazyGetOfferByIdQuery,
  useCreateOfferMutation,
  useUpdateOfferMutation,
  useOfferStatusMutation,
  useLazyPollOfferByIdQuery,
  useUploadReplacementMutation,
  useLazyGetApplicantByIdQuery,
  useSendEmailMutation,
  useSendWithDocuSignMutation,
  useSendWithPandaDocMutation,
  useSendWithAdobeMutation,
  useLazyGetApplicantOfferActivitiesQuery,
  useUploadAttachmentMutation,
} = offerInitiationApi;
